
export default function BlockActiveDirectoryController(
  $location,
  $rootScope,
  $timeout,
  alerts,
  authorizationService,
  userService,
  loaderService,
) {
  const vm = this;

  // Set Default Values
  vm.appIsLoaded = false;
  vm.loginIsProcessing = false;
  vm.password = '';
  vm.saveType = '';
  vm.userName = userService.userName;

  // Attach Event Handlers
  vm.backToLogin = _backToLogin;
  _activate();

  /** ***********************************************
   * Private Functions
   */

  function _activate() {
    // authorizationService.revokeToken();
    loaderService.showViewLoader = false;
    vm.appIsLoaded = true;
  }

  function _backToLogin() {
    $location.path('/login');
  }
}

BlockActiveDirectoryController.$inject = [
  '$location',
  '$rootScope',
  '$timeout',
  'alerts',
  'authorizationService',
  'userService',
  'loaderService',
  'orgDataService',
];
